import React from "react";
//#region types
import { FloatingMessageWithLinkProps } from "models/propTypes/messagePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const FloatingMessageWithLink: React.FC<FloatingMessageWithLinkProps> = ({ message, link }) => {
  return (
    <Grid container direction="row" alignItems="start" flexWrap="nowrap" columnGap={3}>
      <Grid item xs>
        {message}
      </Grid>
      <Grid item className={cssExports.snackbarLink}>
        <a href={link}>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.View)}</a>
      </Grid>
    </Grid>
  );
};

export default FloatingMessageWithLink;
